import React from "react";
import Array from "./Array";

function App() {
  return (
    <Array />
  );
}

export default App;
